import { MutableRefObject } from 'react';
import { fabric } from '../../../../vendor/fabric';

export const handleRect = ({
  canvasRef,
  color,
  callback
}: {
  canvasRef: MutableRefObject<fabric.Canvas | null>;
  color: string;
  callback: () => void;
}) => {
  canvasRef.current.isDrawingMode = false;

  let rect: any = null;
  let startX = 0;
  let startY = 0;

  // Remove any previous listeners to avoid stacking
  canvasRef.current.off('mouse:down');
  canvasRef.current.off('mouse:move');
  canvasRef.current.off('mouse:up');

  // Mouse down: start rectangle
  canvasRef.current.on('mouse:down', opt => {
    const pointer = canvasRef.current.getPointer(opt.e);
    startX = pointer.x;
    startY = pointer.y;

    rect = new fabric.Rect({
      left: startX,
      top: startY,
      width: 0,
      height: 0,
      stroke: color,
      strokeWidth: 3,
      fill: '',
      selectable: false,
      evented: false,
      originX: 'left',
      originY: 'top'
    });

    canvasRef.current.add(rect);
  });

  // Mouse move: update rectangle size
  canvasRef.current.on('mouse:move', function(opt) {
    if (!rect) return;
    const pointer = canvasRef.current.getPointer(opt.e);

    const width = pointer.x - startX;
    const height = pointer.y - startY;

    rect.set({
      width: Math.abs(width),
      height: Math.abs(height),
      left: width < 0 ? pointer.x : startX,
      top: height < 0 ? pointer.y : startY
    });

    canvasRef.current.renderAll();
  });

  // Mouse up: finalize rectangle
  canvasRef.current.on('mouse:up', function() {
    if (rect) {
      rect.set({
        selectable: true,
        evented: true
      });
      canvasRef.current.setActiveObject(rect);
      canvasRef.current.renderAll();
      rect = null;
    }
    // Remove listeners after drawing
    canvasRef.current.off('mouse:down');
    canvasRef.current.off('mouse:move');
    canvasRef.current.off('mouse:up');
    callback();
  });
};
